import { RESPONSE_SUCCESS_CODE } from '@/configs/constants';
import Toast from '@/components/Toast';
import { request } from './request';
import { ApiConfigs, Response } from '../schemas/service';
import { IAreaDetail, IStoreList } from '../schemas/covid';

const api: ApiConfigs = {
  areaDetail: {
    url: '/health/api/v1/nucleicAcid/area/detail',
    method: 'GET'
  },
  getCity: {
    url: '/health/api/v1/nucleicAcid/area/getCity',
    method: 'GET'
  },
  getStoreList: {
    url: '/health/api/v1/nucleicAcid/area/organizations',
    method: 'GET'
  },
  cancelAppoint: {
    url: '/health/api/v1/nucleicAcid/order/cancelAppoint',
    method: 'POST'
  },
  getWorkDates: {
    url: '/health/api/v1/nucleicAcid/area/workDates',
    method: 'GET'
  },
  getPayChannel: {
    url: '/health/api/v1/nucleicAcid/order/queryPayChannel',
    method: 'GET'
  },
  purchase: {
    url: '/health/api/v1/nucleicAcid/order/submitOrder',
    method: 'POST'
  },
  getCustomerList: {
    url: '/health/api/v1/nucleicAcid/order/getReservationUserList',
    method: 'GET'
  },
  saveCustomer: {
    url: '/health/api/v1/nucleicAcid/order/saveReservationUser',
    method: 'POST'
  }
};

const covid = {
  async areaDetail(query) {
    try {
      const response: Response<IAreaDetail> = await request(
        api.areaDetail,
        query,
        undefined,
        { hideGlobalLoading: false }
      );
      const { result } = response;

      if (result && result.price) {
        result.price /= 100;
      }

      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getCityByLocation(latitude: number, longitude: number) {
    try {
      const response: Response<any> = await request(api.getCity, {
        latitude,
        longitude
      });
      const { result } = response;
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getStoreList({ city = '', latitude, longitude }) {
    try {
      const response: Response<IStoreList> = await request(api.getStoreList, {
        latitude,
        longitude,
        city
      });
      const { result } = response;
      if (result) {
        return result;
      }
      return [];
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async cancelAppoint({ id }) {
    try {
      const response: any = await request(api.cancelAppoint, { id }, null, {
        needResponse: true
      });
      const { code, message } = response;
      if (code === RESPONSE_SUCCESS_CODE) {
        return true;
      }
      Toast.show(message);
      return false;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getWorkDates({ organizationId, serverId }) {
    try {
      const response: Response<any> = await request(
        api.getWorkDates,
        {
          organizationId,
          serverId
        },
        undefined,
        { hideGlobalLoading: false }
      );
      const { result } = response;
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getPayChannel({ organizationId, serverId, isAliPay, isWeChat }) {
    try {
      const response: Response<any> = await request(api.getPayChannel, {
        organizationId,
        serverId,
        isWeChat,
        isAliPay
      });
      const { result } = response;
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async purchase({ organizationId, serverId, phone, payChannel }) {
    try {
      const response: Response<any> = await request(
        api.purchase,
        {
          organizationId,
          serverId,
          phone,
          payChannel
        },
        {},
      );
      const { result } = response;
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getCustomerList() {
    try {
      const response: Response<any> = await request(api.getCustomerList);
      const { result } = response;
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async saveCustomer(customer) {
    try {
      const response: Response = await request(api.saveCustomer, {}, customer);
      const { result } = response;
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  }
};

export default covid;
